import { service } from '@ember/service';
import Route from '@ember/routing/route';
import * as Sentry from '@sentry/ember';
import { INVITATION_STORAGE_KEY_NAME } from 'hcp/utils/constants';

export default class AcceptInvitationRoute extends Route {
  @service router;
  @service api;

  org_name = '';

  async beforeModel() {
    let { invitation_token } = this.paramsFor(this.routeName);

    if (!invitation_token) {
      this.router.transitionTo('sign-in');
    }
    // Persist the invitation token in localStorage so that it can be used later.
    // This is necessary because the invitation token is not passed through the
    // authentication flow, so we need to store it in localStorage to retrieve it later.
    localStorage.setItem(INVITATION_STORAGE_KEY_NAME, invitation_token);

    await this.api.invitation
      .invitationsServiceGetOrganizationNameByInvitationToken(invitation_token)
      .then(({ organizationName }) => {
        this.org_name = organizationName;
      })
      .catch((e) => {
        Sentry.captureException(e);
        this.router.transitionTo('sign-in');
      });
  }

  async model() {
    let { invitation_token: invitationToken } = this.paramsFor(this.routeName);
    return {
      invitationToken,
      organizationName: this.org_name,
    };
  }
}
